import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import { fetchSolicitudesByEv } from "../../services/solicitud";
import $ from "jquery";
import {
  ContenedorTabla,
  ContentWrap,
  Div,
  EstadoCell,
  PageContainer,
  StyledLink,
  Title,
} from "./FeedEvaluadorStyle";
import styled from "styled-components";

// Colores corporativos Colbún
const azul = "#147abe";
const gris = "#505259";
const fondoFilaAlterna = "#f9f9f9";

// Tabla con estilo personalizado
const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;

  thead {
    background-color: ${azul};
    color: white;
  }

  th,
  td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid ${gris};
  }

  tbody tr:nth-child(even) {
    background-color: ${fondoFilaAlterna};
  }

  tbody tr:hover {
    background-color: #eef2f7;
  }
`;

function FeedPostulante() {
  const tableId = "#table_id";
  const isTableInitialized = useRef(false);
  const [user, setUser] = useState({});
  const [postulantesData, setPostulantesData] = useState([]);

  useEffect(() => {
    const userData = sessionStorage.getItem("userData");

    if (userData) {
      const parsedUser = JSON.parse(userData);
      setUser(parsedUser);

      if (parsedUser.rol === "Postulante") {
        window.location.href = "/feedPostulante";
      } else if (parsedUser.rol === "Administrador") {
        window.location.href = "/feedAdmin";
      }
    }
  }, []);

  useEffect(() => {
    if (user.rut_usuario) {
      fetchSolicitudesByEv(user.rut_usuario).then((data) => {
        setPostulantesData(data);
      });
    }
  }, [user.rut_usuario]);

  useEffect(() => {
    const config = {
      responsive: true,
      columnDefs: [
        { responsivePriority: 1, targets: 0 },
        { responsivePriority: 2, targets: -1 },
        { responsivePriority: 3, targets: -2 },
        { responsivePriority: 4, targets: 4 },
      ],
      order: [[2, "asc"]],
      language: {
        sProcessing: "Procesando...",
        sLengthMenu: "Mostrar _MENU_ registros",
        sZeroRecords: "No se encontraron registros",
        sEmptyTable: "No hay datos disponibles",
        sInfo:
          "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
        sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
        sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
        sSearch: "Buscar:",
        sLoadingRecords: "Cargando...",
        oAria: {
          sSortAscending:
            ": Activar para ordenar la columna de manera ascendente",
          sSortDescending:
            ": Activar para ordenar la columna de manera descendente",
        },
      },
    };

    if (
      $(tableId).length &&
      !isTableInitialized.current &&
      postulantesData.length > 0
    ) {
      $(tableId).DataTable(config);
      $(tableId).DataTable().columns.adjust();
      $(tableId).DataTable().responsive.recalc();
      isTableInitialized.current = true;
    }
  }, [postulantesData]);

  return (
    <PageContainer>
      <Navbar name={user.nombre_usuario} />
      <ContentWrap>
        <Div>
          <Title>Lista de postulaciones</Title>
          <ContenedorTabla>
            <StyledTable id="table_id" className="display responsive nowrap">
              <thead>
                <tr>
                  <th>Organización Postulante</th>
                  <th>Comuna</th>
                  <th>Región</th>
                  <th>Fecha Postulación</th>
                  <th>Evaluaciones</th>
                  <th>Estado</th>
                  <th>Puntaje</th>
                </tr>
              </thead>
              <tbody>
                {postulantesData.map((postulante) => (
                  <tr key={postulante.id_solicitud}>
                    <td>
                      {postulante.ya_evaluado < 1 ? (
                        <StyledLink
                          to={`/FormularioRevision?id_postulacion=${postulante.id_solicitud}`}
                        >
                          {postulante.nombre_organizacion}
                        </StyledLink>
                      ) : (
                        <span>{postulante.nombre_organizacion} ✅</span>
                      )}
                    </td>
                    <td>{postulante.descripcion_comuna}</td>
                    <td>{postulante.descripcion_region}</td>
                    <td>{postulante.Fecha_Postulacion}</td>
                    <td>
                      {postulante.evaluaciones_count}/
                      {postulante.evaluadores_count}
                    </td>
                    <EstadoCell estado={postulante.estado_solicitud}>
                      {postulante.estado_solicitud}
                    </EstadoCell>
                    <td>{postulante.Puntaje ?? 0}</td>
                  </tr>
                ))}
              </tbody>
            </StyledTable>
          </ContenedorTabla>
        </Div>
      </ContentWrap>
      <Footer />
    </PageContainer>
  );
}

export default FeedPostulante;
